const common = {
  Save: '储存',
  Add: '新增',
  Copy: '复制',
  'Copied to clipboard': '已复制到剪贴簿',
  'Something went wrong. Please try again.': '发生错误，请重新尝试',
  Confirm: '确认',
  Cancel: '取消',
  Close: '关闭',
  Logout: '登出',
  'Upgrade now': '一键升级',
};

export default common;
